import React from 'react'
import { Col, Row } from 'react-bootstrap'
import styles from './switchButtonRow.module.scss'
import {CustomSwitch} from '../customSwitch';

export const CustomSwitchButtonRow = (props) => {
    return (
        <Row className={styles.switchButtonRow}>
            <Col xs={8}>
                <Col className="pl-0">
                    <p className={styles.switchTitle}>{props.Title}</p>
                </Col>
                <Col className="pl-0">
                    <p className={styles.switchDescription}>{props.description}</p>
                </Col>
            </Col>
            <Col xs={{span:2, offset:2}} className="text-right">
                <CustomSwitch 
                    id={props.id}
                    classType={props.isChecked? "animateSwitchActive" :"animateSwitch"}
                    handleChange={props.handleClick}
                    isChecked={props.isChecked}
                    name={props.name}
                    disabled={props.disabled}
                />
            </Col>
        </Row>

    )
}
